import { icons } from './icons'
import { FiatProvider } from '@/pages/Donation/types'
import { IFiatProvider } from '@/pages/Donation/api/streamer/types'

export const processProviders = (providers?: IFiatProvider[]): FiatProvider[] => {
  if (!providers) {
    return []
  }

  return providers.map(provider => ({
    ...provider,
    icon: icons[provider.payment_method],
  }))
}
